import React from "react";

export default function Facebook() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M23.584 19.5L24.2505 15.1566H20.0829V12.338C20.0829 11.1497 20.6651 9.99141 22.5316 9.99141H24.4263V6.29344C24.4263 6.29344 22.707 6 21.063 6C17.6309 6 15.3874 8.08031 15.3874 11.8463V15.1566H11.5723V19.5H15.3874V30H20.0829V19.5H23.584Z"
        fill="#1877F2"
      />
    </svg>
  );
}
